import React from 'react';
import { useProfileWhatsAppAccountsModel } from './model';
import { ProfileWhatsAppAccountsView } from './view';

export const ProfileWhatsAppAccountsWidget: React.FC = () => {
  const {
    state,
    bindings,
    setDefault,
    unbind,
    connect,
    openConnect,
    closeConnect,
    requestConnection,
  } = useProfileWhatsAppAccountsModel();

  return (
    <ProfileWhatsAppAccountsView
      state={state}
      bindings={bindings}
      connect={connect}
      onSetDefault={async (bindingId) => setDefault(bindingId)}
      onUnbind={async (bindingId) => unbind(bindingId)}
      onOpenConnect={async (bindingId) => openConnect(bindingId)}
      onCloseConnect={closeConnect}
      onRequestConnect={requestConnection}
    />
  );
};
